import { Calculator } from "lucide-react";

import styles from "./CalculateInputTrigger.module.css";

export const CalculateInputTrigger = ({
  value,
  onClick,
  disabled,
  placeholder = "Calculate",
}) => (
  <button
    type="button"
    className={`${styles.trigger} ${disabled ? styles.disabled : ""}`}
    onClick={!disabled ? onClick : undefined}
    tabIndex={disabled ? -1 : 0}
  >
    <span className={value ? styles.value : styles.placeholder}>
      {value || placeholder}
    </span>
    <span className={styles.iconWrapper}>
      <Calculator size={16} />
    </span>
  </button>
);
